import { Instance, types, flow } from "mobx-state-tree";
import axios, { AxiosError, AxiosResponse } from "axios";
import { AUTH_REGISTER_PARENT, CHECK_EXISTING_EMAIL } from "@constants/api";
import { AlertResultApi } from "@utils/alert";
import { fetching, FetchingEnum } from "./Fetching";

interface IRegisterData {
  salutation: string;
  firstName: string;
  lastName: string;
  email: string;
  mobileNo: string;
  password: string;
  retypePassword: string;
  billingName: string;
  blockNo: string;
  address: string;
  buildingName: string;
  postalCode: string;
  unitNo: string;
  isTermAndConditions: boolean;
  isWaiverAndIndemnity: boolean;
  isPrivacyPolicy: boolean;
  billingEmails: string[];
  token: string;
}

export const initialStateRegister = {
  state: "done",
  fetchingCheckExistingEmail: FetchingEnum.DONE,
};

export const Register = types
  .model({
    state: types.string,
    status: types.maybeNull(types.number),

    // check email
    fetchingCheckExistingEmail: fetching,
    statusCheckExistingEmail: types.maybeNull(types.number),
  })
  .actions((self) => ({
    postRegister: flow(function* actionLogin(
      data: IRegisterData,
      callback: (result: any) => void
    ) {
      self.state = "pending";
      const billingEmails = data.billingEmails.map((billingEmail, number) => {
        return {
          id: number,
          email: billingEmail,
        };
      });
      try {
        // ... yield can be used in async/await style
        const result = yield axios.request({
          method: "post",
          url: AUTH_REGISTER_PARENT,
          data: {
            user: {
              email: data.email,
              password: data.password,
            },
            salutation: data.salutation,
            firstName: data.firstName,
            lastName: data.lastName,
            securityCode: "",
            mobile: data.mobileNo,
            status: "active",
            billingAddress: {
              blockNumber: data.blockNo,
              postalCode: data.postalCode,
              building: data.buildingName,
              address: data.address,
              unit: data.unitNo,
              name: data.billingName,
            },
            billingEmails: billingEmails,
          },
        });
        self.state = "done";
        // self.token = result.data.token;
        callback(result);
      } catch (error) {
        self.state = "error";
        self.status = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
    checkExistingEmail: flow(function* checkEmail(
      email,
      callback: (status: string) => void
    ) {
      self.fetchingCheckExistingEmail = "pending";
      self.statusCheckExistingEmail = null;
      try {
        const result = yield axios.request({
          method: "post",
          url: CHECK_EXISTING_EMAIL,
          data: {
            email: email,
          },
        });
        self.fetchingCheckExistingEmail = "done";
        self.statusCheckExistingEmail = result.status;
        if (result.data) {
          // Email has been used
          callback("email_exists");
          return;
        }
        callback("email_not_exists");
      } catch (error) {
        self.fetchingCheckExistingEmail = "error";
        self.statusCheckExistingEmail = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
    resetRegister: () => {
      self.state = "done";
      self.status = null;
      self.fetchingCheckExistingEmail = "done";
      self.statusCheckExistingEmail = null;
    },
  }));

export type RootInstanceRegister = Instance<typeof Register>;
